import cx from 'classnames';
import PropTypes from 'prop-types';
import { ArticleCard, Grid, GridItem } from '@bwoty-web/ui-kit';
import { useIsGlobetrotter, useIsMobile } from '@bwoty-web/ui-kit/hooks';

import './PackagePlusOtherOptionsView.scss';

const PackagePlusOtherOptionsView = ({
  initialIsMobile,
  labels,
  mainProductGeoType,
  otherOptions,
}) => {
  const isGlobetrotter = useIsGlobetrotter();
  const isMobile = useIsMobile(initialIsMobile);

  let topGridOptions = [];
  let bottomGridOptions = [];
  if (mainProductGeoType === 'Extra') {
    if (isGlobetrotter && otherOptions?.length > 3) {
      topGridOptions = otherOptions?.slice(0, 3);
      bottomGridOptions = otherOptions?.slice(3);
    } else {
      topGridOptions = otherOptions;
    }
  } else if (isGlobetrotter && otherOptions?.length > 6) {
    topGridOptions = otherOptions?.slice(0, 6);
    bottomGridOptions = otherOptions?.slice(6);
  } else {
    topGridOptions = otherOptions;
  }

  return (
    <div
      className={cx({
        'uikit-box': !isGlobetrotter,
      })}
    >
      <h2 className="geo-package-plus-other-options__heading">
        {labels.otherOptionsHeading}
      </h2>
      {topGridOptions?.length > 0 && (
        <Grid>
          {topGridOptions.map((option) => {
            const { heading, image1Url, text } = option;
            const rowMode = topGridOptions.length > 2;
            let colSpan = isMobile || !rowMode ? 12 : 4;
            let cardProps = {
              className: 'geo-package-plus-other-option__card',
              columnSpan: colSpan,
              description: text,
              image: { cloudinaryUriTemplate: image1Url },
              imageAspectRatio: 16 / 9,
              imagePosition: isMobile || rowMode ? 'top' : 'left',
              imageWidth: 4,
              title: heading,
            };
            if (isGlobetrotter) {
              colSpan = isMobile ? 12 : 4;
              cardProps = {
                ...cardProps,
                columnSpan: colSpan,
                imageAspectRatio: isMobile ? 16 / 9 : 4 / 5,
                imagePosition: 'top',
              };
            }
            return (
              <GridItem key={heading} columnSpan={colSpan}>
                <ArticleCard {...cardProps} />
              </GridItem>
            );
          })}
        </Grid>
      )}
      {isGlobetrotter && bottomGridOptions?.length > 0 && (
        <Grid className="geo-package-plus-other-options__landscape-container">
          {bottomGridOptions.map((option) => {
            const { heading, image1Url, text } = option;
            return (
              <GridItem key={heading} columnSpan={isMobile ? 12 : 6}>
                <ArticleCard
                  className="geo-package-plus-other-option__card"
                  columnSpan={isMobile ? 12 : 6}
                  description={text}
                  image={{ cloudinaryUriTemplate: image1Url }}
                  imageAspectRatio={16 / 9}
                  imagePosition="top"
                  title={heading}
                />
              </GridItem>
            );
          })}
        </Grid>
      )}
    </div>
  );
};

PackagePlusOtherOptionsView.propTypes = {
  initialIsMobile: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    otherOptionsHeading: PropTypes.string,
  }).isRequired,
  mainProductGeoType: PropTypes.string.isRequired,
  otherOptions: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      image1Url: PropTypes.string,
      text: PropTypes.string,
    }),
  ).isRequired,
};

export default PackagePlusOtherOptionsView;
